// authUtils.js
import useAuthStore from '@/stores/authStore';
import { axiosInstance } from '@/lib/api';

/**
 * Local storage utility functions
 * These don't involve API calls and can remain as regular functions
 */

// Store user data in localStorage
export const setUserData = (userData) => {
  localStorage.setItem('user', JSON.stringify(userData));
};

// Get user data from localStorage
export const getUserData = () => {
  const userData = localStorage.getItem('user');
  return userData ? JSON.parse(userData) : null;
};

// Clear user data (for logout)
export const clearUserData = () => {
  localStorage.removeItem('user');
};

/**
 * API-related functions
 * These are non-hook versions that use the axios instance directly
 * Components should prefer using the useAuth hook when possible
 */

// Fetch current user data from the API (non-hook version)
export const fetchCurrentUser = async () => {
  console.log('DEBUG: fetchCurrentUser called');
  try {
    console.log('DEBUG: Making API request to /api/auth/me');
    const response = await axiosInstance.get('/api/auth/me');
    console.log('DEBUG: /api/auth/me response received:', response.data);

    if (response.data.success && response.data.user) {
      // Set the user data in the Zustand store
      const setUser = useAuthStore.getState().setUser;
      console.log('DEBUG: Setting user data in store from fetchCurrentUser');
      setUser(response.data.user);
      return response.data.user;
    }
    return null;
  } catch (error) {
    console.error('Error fetching current user:', error);
    return null;
  }
};

// Handle Google OAuth login
export const handleGoogleLogin = () => {
  window.location.href = `${import.meta.env.VITE_API_URL}/api/auth/google`;
};

// Export a message to encourage using the hook version
export const AUTH_UTILS_DEPRECATION_NOTICE =
  'Consider using the useAuth hook for components that need API functionality';
